<script>
import resources from './resources'
import {TheMask} from 'vue-the-mask'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'profile',
  mixins: [resources],
  components: {
    TheMask
  }
}
</script>


<template lang="pug">
  section.content.profile-page
    page
    .container-fluid
      .block-header
        .row.clearfix
          .col-lg-5.col-md-5.col-sm-12
            h2 Perfil
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') {{ user.name}}
              li.breadcrumb-item.active Perfil
          //-.col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(type='text', placeholder='Search...')
              span.input-group-addon
                i.zmdi.zmdi-search
      .row.clearfix
        .col-lg-12.col-md-12
          .card
            .body.bg-dark.profile-header
              .row(style="min-height: 115px;")
                .col-lg-10.col-md-12
                  div.cursor-pointer#uploadAvatar
                    img.user_pic.rounded.img-raised(
                      v-if="user.image !== null"
                      :src='user.image', alt='User',
                      style="width: 180px;"
                    )
                    img.user_pic.rounded.img-raised(
                      v-if="user.image === null"
                      src='/static/images/profile_av.jpeg',
                      alt='User'
                      style="width: 180px;"
                    )
                  .row
                    f-avatar
                  .detail
                    .u_name
                      h4
                        strong {{ user.name}}
                      span {{ getTypeUser() }}

                //-.col-lg-2.col-md-12.user_earnings
                  h6 Total Earnings
            ul.nav.nav-tabs.profile_tab
              li.nav-item
                a.nav-link.cursor-pointer.active(data-toggle='tab') Visão Geral
              li.nav-item
                router-link.nav-link.cursor-pointer(:to="{name: 'dweller.profile.schedules.me'}") Agendamentos
              li.nav-item
                router-link.nav-link.cursor-pointer(:to="{name: 'dweller.profile.me.me'}") Perfil
          .tab-content
            over-view

</template>



// WEBPACK FOOTER //
// src/app/tenant/profile/me/overview.vue